import { Component, computed, inject, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Facility, TravelHealth } from '@core/models/domains/hotel';
import { SearchBoxService } from '@shared/services/serach-box.service';

@Component({
  selector: 'iho-hotel-facilities-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './hotel-facilities-modal.component.html',
  styleUrls: ['./hotel-facilities-modal.component.scss'],
})
export class HotelFacilitiesModalComponent {
  searchBoxService = inject(SearchBoxService);
  accommodation = computed(() => this.searchBoxService.accommodation());

  otherFacilities:Facility =
    {
      Id: 0,
      Name: 'امکانات مهم دیگر',
      Description: '',
      SvgPic: '',
      IconClassName: '',
      HotelFacilities: [
     
      ]
    }
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {dataSource: Facility[]; hotelFullName: string;
       travelHealth: TravelHealth,alternativeFacilities:any, type:number },
    public dialogRef: MatDialogRef<HotelFacilitiesModalComponent>
  ) {
  }

  replaceIcon(ico:string){
    if(ico.includes('_'))
    return ico.split('_')[0] + '-' + ico.split('_')[1][0].toUpperCase() + ico.split('_')[1].slice(1);
  else
    return ico;

  }
}
